
import { getUserRole } from "@/service/userrole.service";
import { getStation } from "@/service/station.service";
import {
  getUserById,
  putUser,
  saveAvailableRoutes,
  getAvailableRoutes,
} from "@/service/user.service";
import { defineComponent } from "@vue/runtime-core";
import { User } from "@/types/user.type";
import { UserRole } from "@/types/userrole.type";
import { ElMessage } from "element-plus";
import { getSamplingPointNames } from "@/service/samplingpoint.service";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { Station } from "@/types/station.type";
import UserPassFormComponent from "./UserPassForm.component.vue";
import ComponentNewMenuItem from "@/components/ModalNewMenuItem.component.vue";
import { MenuItem } from "@/types/menuItem.type";

export default defineComponent({
  components: { UserPassFormComponent, ComponentNewMenuItem },
  props: {
    id: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      userForm: {} as User,
      oldUser: {} as User,
      userRole: [] as UserRole[],
      samplingpoints: [] as SamplingPoint[],
      stations: [] as Station[],
      roles: [] as number[], // Identificadores de los roles
      visualiceModalMenus: false as boolean,
      menuItems: [] as MenuItem[],
      rolesString: [
        "U.C.Visualizador",
        "U.C.Configurador",
        "U.C.Agente de Campo",
        "U.E.Visualizador",
        "U.E.Configurador",
        "U.E.Mantenimiento",
      ],

      samNumbers: [] as number[],
      stationsNumber: [] as number[],

      showSamPoint: false,
      showStation: false,
      names: [] as string[],
      showPassDialog: false,
      innerVisible: false,
      userSelected: [] as number[],
      titleDialog: this.$t("label.titlePassword"),

      availableRoutesList: [
        { label: "Support - Home", value: "/support" },
        { label: "Support - Sampling Points", value: "/support/samplingPoints" },
        { label: "Support - Alerts", value: "/support/alerts" },
        { label: "Support - Import", value: "/support/import" },
        { label: "Support - Gallery", value: "/support/gallery" },
        { label: "Support - Report", value: "/support/report" },
        { label: "Stations - Home", value: "/stations" },
        { label: "Stations - Stations", value: "/stations/stations" },
        { label: "Stations - Alerts", value: "/stations/alerts" },
        { label: "Stations - Sampling Points", value: "/stations/samplingPoints" },
        { label: "Stations - Graph", value: "/stations/graph" },
        { label: "Stations - Report", value: "/stations/report" },
        { label: "Process-Tracking - Home", value: "/process-tracking" },
        { label: "Process-Tracking - Lista puntos", value: "/process-tracking/samplingpoints" },
        { label: "Process-Tracking - Subir datos", value: "/process-tracking/upload" },
        { label: "Process-Tracking - Cargar datos", value: "/process-tracking/trainingdata" },
        {
          label: "Process-Tracking - Descarga datos",
          value: "/process-tracking/downloadTrainingData",
        },
        { label: "Issue-Monitoring - Home", value: "/issue-monitoring" },
        { label: "Issue-Monitoring - Lista puntos", value: "/issue-monitoring/samplingpoints" },
        { label: "Issue-Monitoring- Histórico", value: "/issue-monitoring/list" },
      ],
      availableRoutes: [] as string[],

      aquacorpMemberOption: [
        { label: "Miembro", value: "Member" },
        { label: "No miembro", value: "No Member" },
      ],
      aquacorpMember: [] as string[],
      rules: {
        name: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
            // validator: this.validateEmail(),
          },
        ],
        userName: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        dateregistration: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        timeregistration: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        permissions: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        // aquacorpMember: [
        //   {
        //     required: true,
        //     message: this.$t("error.required"),
        //     trigger: "blur",
        //   },
        // ],
      },
    };
  },
  methods: {
    getNamesPermissions() {
      this.userForm.permissions?.forEach((role) => {
        if (role) {
          this.userRole.push(role);
        }
      });
    },
    /**
     * Obtener los identificadores de los roles.
     */
    getRoles() {
      this.userForm.permissions?.forEach((role) => {
        if (role.id) {
          this.roles.push(role.id);
        }
      });
    },
    close() {
      this.visualiceModalMenus = false;
    },
    // open() {
    //   this.visualiceModalMenus = true;
    // },
    async configMenuItems() {
      this.visualiceModalMenus = true;
      let menuItemsSelect = await (
        this.$refs["menuDialog"] as InstanceType<typeof ComponentNewMenuItem>
      ).saveItemSelect();
      this.userForm.menuItems = menuItemsSelect;

      this.visualiceModalMenus = false;
    },

    async saveRoutes() {
      try {
        if (this.oldUser.id !== undefined) {
          const payload = {
            userId: this.oldUser.id,
            availableRoutes: this.availableRoutes,
          };

          await saveAvailableRoutes(payload);
        } else {
          // eslint-disable-next-line no-console
          console.log("Error: userId no está definido");
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log("Error:", error);
      }
    },

    async modifyUser() {
      if (this.oldUser.id) {
        this.userForm.permissions = [];
        let isAdmin = false;
        for (let role of this.roles) {
          this.userForm.permissions.push(this.userRole[role - 1]);
          if (this.userRole[role - 1].id === 7) {
            isAdmin = true;
          }
        }
        if (isAdmin) {
          this.userForm.permissions?.splice(0, this.userForm.permissions.length);
          this.userForm.permissions?.push(this.userRole[6]);
          this.userForm.samplingPoints?.splice(0, this.userForm.samplingPoints.length);
          this.userForm.stations?.splice(0, this.userForm.stations.length);
        } else {
          this.removeItems();
        }

        //Guardar rutas disponibles
        await this.saveRoutes();
        await putUser(this.oldUser.id, this.userForm).then(() => {
          this.showPassDialog = false;
        });
      }
    },
    toggleSelectAll() {
      if (this.availableRoutes.length === this.availableRoutesList.length) {
        this.availableRoutes = [];
      } else {
        this.availableRoutes = this.availableRoutesList.map((route) => route.value);
      }
    },

    /**
     * Delete unselected items according to roles
     */
    removeItems() {
      if (
        !this.roles.includes(1) &&
        !this.roles.includes(2) &&
        !this.roles.includes(3) &&
        !this.roles.includes(8)
      ) {
        this.userForm.samplingPoints?.splice(0, this.userForm.samplingPoints.length);
      } else if (!this.roles.includes(4) && !this.roles.includes(5) && !this.roles.includes(6)) {
        this.userForm.stations?.splice(0, this.userForm.stations.length);
      }
    },
    resetUser() {
      // TODO Restaurar el usuarior
      this.userForm = Object.assign({}, this.oldUser);
    },
    openDialogPassword() {
      this.showPassDialog = true;
    },
    async changePassword() {
      const password = (
        this.$refs["userPassForm"] as InstanceType<typeof UserPassFormComponent>
      ).changePass();
      password.then(async (pass) => {
        userEdit.password = pass;
        if (this.oldUser.id) {
          await putUser(this.oldUser.id, userEdit).then(() => {
            this.showPassDialog = false;
            ElMessage.success(this.$t("success.action"));
            this.userForm.password = pass;
          });
        }
      });
      let userEdit = Object.assign({}, this.oldUser);
    },
  },

  async mounted() {
    if (this.id) {
      // Obtener el usuario por su ID
      this.oldUser = await getUserById(this.id);
      this.userForm = Object.assign({}, this.oldUser);

      if (this.oldUser.permissions && this.oldUser.permissions[0].id === 7) {
        this.availableRoutesList.push(
          { label: "Admin - Home", value: "/admin" },
          { label: "Admin - Stations", value: "/admin/stations" },
          { label: "Admin - Containers", value: "/admin/containers" },
          { label: "Admin - Sampling Points", value: "/admin/samplingPoints" },
          { label: "Admin - Users", value: "/admin/users" },
          { label: "Admin - Parameters", value: "/admin/parameters" }

          // { label: 'Admin - Open Data', value: '/admin/opendata' },
          // { label: 'Admin - Saica', value: '/admin/saica' },
          // { label: 'Admin - Saih', value: '/admin/saih' },
          // { label: 'Admin - Aemet', value: '/admin/aemet' },

          // { label: 'Admin - Upload Data', value: '/admin/upload' },
          // { label: 'Admin - Upload Training Data', value: '/admin/trainingdata' },
          // { label: 'Admin - Download Images', value: '/admin/downloadImages' },

          // { label: 'Admin - Download Optical Data', value: '/admin/downloadOpticalData' },
          // { label: 'Admin - Download Training Data', value: '/admin/downloadTrainingData' },
        );
      }

      let userRoutes = await getAvailableRoutes(this.id);

      if (userRoutes) {
        this.availableRoutes = this.availableRoutesList
          .filter((route) => userRoutes.includes(route.value))
          .map((route) => route.value);
      }
    } else {
      this.userForm = {} as User;
    }
    this.userRole = await getUserRole();
    this.samplingpoints = await getSamplingPointNames();
    this.stations = await getStation();

    this.getRoles();
    if (this.oldUser.menuItems) this.menuItems = this.oldUser.menuItems;
  },
});
